if (!customElements.get('pack-offers')) {
  customElements.define(
    'pack-offers',
    class PackOffers extends HTMLElement {
      connectedCallback() {
        this.opciones = Array.from(this.querySelectorAll('.pack-offer'));
        this.paneles = Array.from(this.querySelectorAll('.pack-offers__panel'));
        this.seleccion = this.querySelector('.pack-offer.is-selected') || this.opciones[0];
        if (!this.seleccion) return;

        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));

        // Los botones de agregar viven fuera: la ficha y la barra fija.
        document.addEventListener('click', this.onSubmitClick, true);

        this.paintButton();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onSubmitClick, true);
      }

      get panel() {
        if (this.seleccion.dataset.kind !== 'pack') return null;
        return this.paneles.find((p) => p.dataset.panel === this.seleccion.dataset.panel) || null;
      }

      get units() {
        return parseInt(this.seleccion.dataset.units, 10) || 0;
      }

      get total() {
        if (!this.panel) return 0;
        return Array.from(this.panel.querySelectorAll('.pb-qty__input')).reduce(
          (suma, input) => suma + (parseInt(input.value, 10) || 0),
          0
        );
      }

      onClick(event) {
        const opcion = event.target.closest('.pack-offer');
        if (opcion) return this.select(opcion);

        const paso = event.target.closest('.pb-qty__step');
        if (paso) return this.step(paso);
      }

      onChange(event) {
        if (!event.target.classList.contains('pb-qty__input')) return;

        const actual = parseInt(event.target.value, 10) || 0;
        const otros = this.total - actual;
        event.target.value = Math.max(0, Math.min(actual, this.units - otros));
        this.refresh();
      }

      select(opcion) {
        this.opciones.forEach((o) => {
          const activa = o === opcion;
          o.classList.toggle('is-selected', activa);
          o.setAttribute('aria-pressed', String(activa));
        });

        this.seleccion = opcion;
        this.paneles.forEach((p) => {
          p.toggleAttribute('hidden', p.dataset.panel !== opcion.dataset.panel);
        });

        this.refresh();
      }

      step(boton) {
        const input = boton.parentElement.querySelector('.pb-qty__input');
        const actual = parseInt(input.value, 10) || 0;
        const otros = this.total - actual;
        const siguiente = actual + parseInt(boton.dataset.step, 10);

        input.value = Math.max(0, Math.min(siguiente, this.units - otros));
        this.refresh();
      }

      refresh() {
        const panel = this.panel;
        if (panel) {
          const total = this.total;
          const faltan = this.units - total;
          const contador = panel.querySelector('[data-count]');
          if (contador) contador.textContent = total;

          panel.querySelectorAll('[data-step="1"]').forEach((paso) => {
            paso.disabled = total >= this.units;
          });

          if (faltan === 0) panel.querySelector('.pack-options-notice')?.setAttribute('hidden', '');
        }

        this.paintButton();
      }

      // El boton del tema muestra el precio de lo que se agregara.
      paintButton() {
        const etiqueta = `${this.dataset.addLabel} · ${this.seleccion.dataset.price}`;

        document.querySelectorAll(`[form="${this.dataset.form}"], #${this.dataset.form} [type="submit"]`).forEach((boton) => {
          const span = boton.querySelector('span');
          if (span && !boton.closest('pack-offers')) span.textContent = etiqueta;
        });
      }

      onSubmitClick(event) {
        const boton = event.target.closest?.('button[type="submit"]');
        if (!boton || boton.closest('pack-offers')) return;

        const form = boton.form || document.getElementById(boton.getAttribute('form') || '');
        if (!form || form.getAttribute('id') !== this.dataset.form) return;

        // Unidad suelta: que el formulario del tema haga lo suyo.
        if (this.seleccion.dataset.kind !== 'pack') return;

        event.preventDefault();
        event.stopPropagation();

        const panel = this.panel;
        const faltan = this.units - this.total;

        if (faltan > 0) {
          const aviso = panel.querySelector('.pack-options-notice');
          const texto = panel.querySelector('[data-notice]');
          if (texto && this.dataset.remainingLabel) {
            texto.textContent = this.dataset.remainingLabel.replace('[n]', faltan);
          }
          aviso?.removeAttribute('hidden');
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        // Los sabores entran sueltos y el cupon del tramo pone el precio.
        const items = [];
        const properties = {};
        let sueltos = true;

        panel.querySelectorAll('.pb-flavor').forEach((fila) => {
          const cantidad = parseInt(fila.querySelector('.pb-qty__input').value, 10) || 0;
          if (cantidad === 0) return;

          properties[fila.dataset.flavor] = cantidad;
          if (fila.dataset.variant) {
            items.push({ id: Number(fila.dataset.variant), quantity: cantidad });
          } else {
            sueltos = false;
          }
        });

        // Igual que en el armador del inicio: solo las colecciones marcadas
        // entran sueltas, las demas siguen siendo un producto pack.
        if (!this.seleccion.hasAttribute('data-loose') || !sueltos || !window.packTiers) {
          this.addToCart(boton, [{ id: Number(this.seleccion.dataset.variant), quantity: 1, properties }]);
          return;
        }

        this.addToCart(boton, items);
      }

      async addToCart(boton, items) {
        const drawer = document.querySelector('cart-drawer');
        boton.classList.add('loading');

        try {
          if (window.packTiers) {
            await window.packTiers.agregar(items);
            this.reset();
            return;
          }

          const respuesta = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items,
              sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
              sections_url: window.location.pathname,
            }),
          });

          const resultado = await respuesta.json();
          if (resultado.status) throw new Error(resultado.description || resultado.message);

          this.reset();
          if (drawer) drawer.renderContents(resultado);
          else window.location.href = window.routes.cart_url;
        } catch (e) {
          window.location.href = window.routes.cart_url;
        } finally {
          boton.classList.remove('loading');
        }
      }

      reset() {
        this.panel?.querySelectorAll('.pb-qty__input').forEach((input) => {
          input.value = 0;
        });
        this.refresh();
      }
    }
  );
}
